export class KnowledgeFile {
    constructor(model) {
        this.id = model.id;
        this.workspaceId = model.workspaceId;
        this.createdByUserId = model.createdByUserId;
        this.createdAt = new Date(model.createdAt);
        this.updatedAt = new Date(model.updatedAt);
        this.contentUpdatedAt = new Date(model.contentUpdatedAt);
        this.path = model.path;
        this.description = model.description;
        this.file = model.file;
    }
    toRemote() {
        return {
            id: this.id,
            workspaceId: this.workspaceId,
            createdByUserId: this.createdByUserId,
            createdAt: this.createdAt.toISOString(),
            updatedAt: this.updatedAt.toISOString(),
            contentUpdatedAt: this.contentUpdatedAt.toISOString(),
            path: this.path,
            description: this.description,
            file: this.file,
        };
    }
}
export class KnowledgeSkill {
    constructor(model) {
        this.id = model.id;
        this.workspaceId = model.workspaceId;
        this.createdByUserId = model.createdByUserId;
        this.createdAt = new Date(model.createdAt);
        this.updatedAt = new Date(model.updatedAt);
        this.contentUpdatedAt = new Date(model.contentUpdatedAt);
        this.path = model.path;
        this.name = model.name;
        this.description = model.description;
        this.content = model.content;
    }
    toRemote() {
        return {
            id: this.id,
            workspaceId: this.workspaceId,
            createdByUserId: this.createdByUserId,
            createdAt: this.createdAt.toISOString(),
            updatedAt: this.updatedAt.toISOString(),
            contentUpdatedAt: this.contentUpdatedAt.toISOString(),
            path: this.path,
            name: this.name,
            description: this.description,
            content: this.content,
        };
    }
}
